module.exports = __webpack_public_path__ + "static/media/medReim.87d51f21.svg";